import React from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';

class EndpointList extends React.Component {
    buildUrlList() {
        const items = this.props.endpoints.map((endpoint, key) => {
            return (
                <ListGroupItem key={key} header={endpoint.name} href={endpoint.url}>
                    {endpoint.url}
                </ListGroupItem>
            );
        });

        return (
            <ListGroup>
                {items}
            </ListGroup>
        );
    }

    render() {
        return (
            <div>
                <ContentHeader title={this.props.title} />
                <ContentBody>
                    {this.buildUrlList()}
                </ContentBody>
            </div>
        );
    }
}

export default EndpointList;



// WEBPACK FOOTER //
// ./src/areas/admin/console/endpointsInfo/EndpointList.js